import React from 'react'
import { View, StyleSheet, Text} from 'react-native';
import {THEME_COLORS, FONT_SIZE, FONT_FAMILY} from "../styles";

interface ICarDetailTwoProps {
    carObject: {
        make: string;
        model: string;
        variant: string;
        registrationNo: string;
        color: string;
        fuelType: string;
        year: string;
        mileage: string;
        transmission: string;
    }
}

const CarDetailTwo = (props: ICarDetailTwoProps) => {
    const carObject = props.carObject;
    const color = carObject.color;
    const registrationNo = carObject.registrationNo;
    const fuelType = carObject.fuelType;
    const year = carObject.year.slice(2);
    const mileage = carObject.mileage;
    const transmission = carObject.transmission;
    const make = carObject.make;
    const model = carObject.model;
    const variant = carObject.variant;

    return (
        <View>
            <Text style={[{ fontSize: FONT_SIZE.s1, }, styles.text]}>{make}</Text>
            <View style={{width:"60%"}}>
                <Text style={[{ fontSize: FONT_SIZE.s1, marginVertical: 4, }, styles.text]}>{model} - {variant}</Text>
            </View>
            {registrationNo || color || fuelType ? (<Text style={[{ fontSize: FONT_SIZE.s2, fontFamily: FONT_FAMILY.primary, marginVertical:4 }, styles.text]}>
                {registrationNo ? `${registrationNo}` : ''}{color ? ` | ${color}` : ''}{fuelType ? ` | ${fuelType}` : ''}
            </Text>) : null}
            {year || mileage || transmission ? (
                <Text style={{ fontSize: FONT_SIZE.s1, color: THEME_COLORS.black2 }}>{year ? year : ''}{mileage ? ` | ${mileage}` : ''}{transmission ? ` | ${transmission}` : ''}</Text>) : null}
        </View>
    )
};

const styles = StyleSheet.create({
    text: {
        fontWeight: '500',
        color: '#200e36'
    }
});

export default CarDetailTwo;